import Modal from '../components/modal';

(function() {

  var ORIGINAL_LABEL = 'Request a Demo →';

  function successModal() {
    new Modal({
      width: 400,
      header: 'Thanks!',
      text: 'We will be in touch with you soon. In the meantime, take a look at the <a href="/insider">MultiState Insider</a>.'
    });
  }

  function failureModal() {
    new Modal({
      width: 400,
      header: 'Whoops',
      text: 'We were unable to submit your request.',
      error: 'Please try again, or reach out directly at info@multistate.us.',
      success: false
    });
  }

  function submitForm(e) {
    e.preventDefault();
    var form = e.target;
    var submit = form.querySelector('[type="submit"]');
    if (submit.disabled) return;

    submit.disabled = true;
    submit.value = 'Submitting...';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', form.action);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function() {
      if (xhr.status === 200) {
        successModal();
        submit.value = 'Request Sent';
      } else {
        failureModal();
        submit.disabled = false;
        submit.value = ORIGINAL_LABEL;
      }
    };
    xhr.onerror = function() {
      failureModal();
      submit.disabled = false;
      submit.value = ORIGINAL_LABEL;
    };
    xhr.send(new FormData(form));
  }

  function attachFormHandlers() {
    document.querySelectorAll('form.demo-form').forEach(function(form) {
      form.addEventListener('submit', submitForm);
    });
  }

  document.addEventListener('turbolinks:load', attachFormHandlers);
})()
